import { FormControl, Grid, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { KeyboardBackspaceOutlined } from '@material-ui/icons';
import { Alert, AlertTitle } from '@material-ui/lab';
import axios from 'axios';
import { Form, Formik, FormikProps } from 'formik';
import { useSnackbar } from 'notistack';
import { FunctionComponent } from 'react';
import { useHistory } from "react-router-dom";
import { AppInput } from '../components/atoms/inputs/AppInput';
import { LoadingButton } from '../components/atoms/inputs/LodingButton';
import { AuthShell } from '../components/molecules/auth-shell/AuthShell';
import { ApiResponse } from '../types';

const useStyles = makeStyles((theme) => ({
    ppoInput: {
        "& label": {
            color: theme.palette.primary.main,
        },

    }

}));

type ApplStatusState = {
    applNo: string,
    erpId: string,
    message: { type: "error" | "success", text: string } | null
}

type KnowApplStatusPageProps = {
}

export const KnowApplStatusPage: FunctionComponent<KnowApplStatusPageProps> = () => {
    const classes = useStyles();
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();

    return (
        <AuthShell>
            <Formik
                initialValues={{
                    applNo: '',
                    erpId: '',
                    message: null
                }}
                validate={(values) => {
                    const error: Partial<ApplStatusState> & { general?: string } = {}
                    if (!values.applNo) {
                        error.applNo = "Invalid application no (অবৈধ আবেদন নম্বর)"
                    }
                    // if (!values.erpId || !values.erpId.match(/^9\d{9}$/)) {
                    //     error.erpId = "Invalid ERP ID (অবৈধ ERP আইডি)"
                    // }
                    return error
                }}
                onSubmit={async (values, { setSubmitting, setFieldValue, resetForm, setFieldTouched, setFieldError }) => {
                    setSubmitting(true)
                    setFieldValue('message', null)
                    axios.post<ApiResponse<{}>>(`/api/pensioner/ppo-application-status`, {
                        appl_no: values.applNo,
                        erp_id: values.erpId
                    })
                        .then(
                            ({ data: resp }) => {
                                if (resp.status === "success") {
                                    resetForm()
                                    setFieldValue('message', { type: 'success', text: resp.message })
                                    enqueueSnackbar(resp.message, { variant: 'success' })
                                } else {
                                    setFieldValue('message', { type: 'error', text: resp.message })
                                    enqueueSnackbar(resp.message || 'Error Occured', { variant: 'error' })
                                }
                                setSubmitting(false)
                            },
                            () => {
                                setFieldValue('message', { type: 'error', text: "Network error" })
                                enqueueSnackbar('Network error', { variant: 'error' })
                                setSubmitting(false)
                            }
                        )
                    // await new Promise(res => setTimeout(res, 1000)).then(() => {
                    //     setFieldValue('contactNo', 'XXXXXXX9509')
                    //     setFieldValue('state', 1)
                    // })
                }}
            >{({ values, isSubmitting, isValid, setFieldValue, setValues, handleChange }: FormikProps<ApplStatusState>) => {
                return (
                    <Form>
                        <Grid container
                            spacing={3}
                            direction="column"
                            justify="space-around"
                            alignItems="stretch">

                            <Grid item container justify="flex-start" alignItems="center">
                                <Grid item xs={2}><IconButton onClick={() => history.push('/login')}> <KeyboardBackspaceOutlined fontSize="large" /></IconButton></Grid>
                                <Grid item xs={10}><Typography variant="h6" color="primary">Know Application Status (আবেদনের স্থিতি জানুন)</Typography></Grid>
                            </Grid>
                            {
                                values.message &&
                                <Grid item>
                                    <Alert severity={values.message.type}>
                                        <AlertTitle>
                                            {values.message.type === "success" ? "Success" : "Error(ত্রুটি)"}
                                        </AlertTitle>
                                        {values.message.text}
                                    </Alert>
                                </Grid>
                            }
                            <Grid item>
                                <FormControl variant="filled" fullWidth>
                                    <AppInput fullWidth={true} inputProps={{ maxLength: 20 }} name="applNo" label="Application No (আবেদন নম্বর)" className={classes.ppoInput} />
                                </FormControl>
                                <FormControl variant="filled" fullWidth>
                                    <AppInput fullWidth={true} inputProps={{ maxLength: 10 }} name="erpId" label="ERP Id starting with 9 (ইআরপি আইডি 9 দিয়ে শুরু হচ্ছে)" className={classes.ppoInput} />
                                </FormControl>
                            </Grid>
                            <Grid item container justify="space-between">
                                <Grid item>
                                    <LoadingButton
                                        type="submit"
                                        color="primary"
                                        variant="contained"
                                        size="large"
                                        loading={isSubmitting}
                                    >Get Application Status (আবেদনের স্থিতি পান)</LoadingButton>
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
                    </Form>
                )
            }}
            </Formik>
        </AuthShell>
    )
}